import type React from 'react';

import { ButtonGroup, FormField, FormHelp, Label } from '@zillow/constellation-10';

type Props = {
  children: React.ReactNode;
};

export default function PetsBaseRentButtonGroup({ children }: Props) {
  return (
    <FormField
      required
      label={<Label>Is there a pet charge in addition to the base rent?</Label>}
      description={<FormHelp>Base rent is the rent before other fees such as parking or utilities are added</FormHelp>}
      control={
        <ButtonGroup orientation="vertical" conjoined aria-label="pets-charge-type" css={{ width: '100%' }}>
          {children}
        </ButtonGroup>
      }
    />
  );
}
